Chart.defaults.locale = 'fr-FR';
Chart.defaults.font.size = '14px';
Chart.defaults.font.family = 'Manrope, sans-serif';
Chart.defaults.padding = 0;
Chart.defaults.plugins.tooltip.boxWidth = 8;
Chart.defaults.plugins.tooltip.boxHeight = 8;
Chart.defaults.plugins.tooltip.boxPadding = 4;
Chart.defaults.plugins.tooltip.backgroundColor = '#101010';
Chart.defaults.plugins.tooltip.padding = 16;
Chart.defaults.plugins.tooltip.cornerRadius = 6;
Chart.defaults.plugins.tooltip.caretSize = 12;
Chart.defaults.plugins.borderwidth = 0;
